import caseExports from "apis/caseExports";
import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";

export const getAvailableExports = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: caseExports.getAvailableExports(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});

export const getExportResults = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: caseExports.getExportResults(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});

export const startExport = (controlIdNumber, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: payload,
  endpoint: caseExports.startExport(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});

export const markExportForRetry = (controlIdNumber, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: payload,
  endpoint: caseExports.retryExport(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});
